import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {MatPaginator, MatTableDataSource} from '@angular/material';

import { LoggedinService } from '../../../services/login/loggedin.service';
import { TasksService } from '../../../services/tasks/tasks.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import { roleID } from '../../../configurations/configuration';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit {

  _taskData = [];
  showLoader: boolean = true;
  roleID = roleID;
  taskDataFiltered = [];
  @Input() isViewAll;
  @Input() set taskData(value: any) {
    this._taskData = value;
    console.log(this._taskData);
    if(this._taskData.length >= 0) {
      this.showLoader = false;
      this.taskDataFiltered = [];
      this._taskData.forEach(element => {
        if(this.role!==roleID.SALES_REP_ROLE_ID) {
          this.taskDataFiltered.push(element);
        }
        else if((this.role === roleID.SALES_REP_ROLE_ID || this.role === roleID.MARKETING_ROLE_ID)  && element.taskTitle !== 'Reconcile Event') {
          this.taskDataFiltered.push(element);
        }
      })
      // this.taskDataFiltered = this._taskData;
    }
    else {
      this.showLoader = false;
    }
  }
  get taskData(): any {
    // other logic
    return this.taskDataFiltered;
  }
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  filterObj = {};
  user: any;
  role: number;
  constructor(public loggedInService: LoggedinService, private tasksService: TasksService) { }

  ngOnInit() { 
    this.showLoader = true;
    this.user = SessionHelper.getSession();
    console.log(this.user)
    this.filterObj = {
      userId: this.user.id,
      brandId: this.user.brand_id
    }  
    console.log(this.filterObj);
    this.user = SessionHelper.getSession();
    this.role = this.user.role_id;
    console.log(this.role);
    this.filterObj = {
      userId: this.user.id,
      brandId: this.user.brand_id
    } 
  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }
}
